import React, { Component } from 'react'
import { apiProcess } from '../api/api.js'
import { convertCents } from '../utils'

export const withGetPricing = (WrappedComponent, callOnMount) => {
  return class PricingHOC extends Component {
    constructor(props) {
      super(props)
      this.state = {
        pricingInfo:
          this.props.defaultPricingInfo !== {}
            ? this.props.defaultPricingInfo
            : {},
        pricingError: false,
        hasPricingInfo: this.props.defaultPricingInfo !== {} ? true : false,
        loading: false,
      }
    }

    componentDidMount() {
      if (callOnMount) {
        this.doPricingApiCall()
      }
    }

    calculatePricing = (pricingOptions) => {
      this.setState({
        loading: true,
        pricingError: false,
      })

      let callObject = this.buildCallObject(pricingOptions)

      this.doPricingApiCall(callObject)
    }

    giveDefaultValues = (defaultPricing, discountData) => {
      if (
        defaultPricing.available_services.road_side_assistance_fee
          .daily_road_side_assistance_cents
      ) {
        defaultPricing.line_items.forEach((element, index) => {
          if (element.type == 'roadside_assistance') {
            defaultPricing.line_items.splice(index, 1)
          }
        })
      }
      if (
        defaultPricing.available_services.tire_protection_fee
          .daily_tire_protection_cents
      ) {
        defaultPricing.line_items.forEach((element, index) => {
          if (element.type == 'tire_protection') {
            defaultPricing.line_items.splice(index, 1)
          }
        })
      }

      defaultPricing.totals.grand_total.grand_total_cents -=
        defaultPricing.totals.roadside_assistance_total
          .roadside_assistance_total_cents +
        defaultPricing.totals.tire_protection_total.tire_protection_total_cents
      if (defaultPricing.totals.grand_total.grand_total_cents < 0) {
        defaultPricing.totals.grand_total.grand_total_cents = 0
        defaultPricing.totals.applied_rider_credits.applied_rider_credits_cents = 0
        defaultPricing.totals.applied_rider_credits.skip_applied_rider_credits = true
      }

      this.setState({
        pricingInfo: defaultPricing,
        loading: false,
        hasPricingInfo: true,
        pricingError: false,
      })
    }

    buildCallObject = (pricingOptions) => {
      let callObject = {
        birthdate: pricingOptions.birthdate,
        roadside_assistance: pricingOptions.roadside_assistance,
        tire_protection: pricingOptions.tire_protection,
        increased_liability_protection: pricingOptions.increased_liability_protection,
        rider_insurance: pricingOptions.rider_insurance,
        promotion_code: pricingOptions.promotion_code
          ? pricingOptions.promotion_code
          : null, //set this to null
        use_all_free_days: pricingOptions.use_all_free_days,
        use_all_twisted_road_credits:
          pricingOptions.use_all_twisted_road_credits,
        motorcycle_pretty_id: pricingOptions.motorcycle_pretty_id.toUpperCase(),
        start_at: pricingOptions.time_info.start_at,
        end_at: pricingOptions.time_info.end_at,
        delivery_latitude: pricingOptions.delivery_latitude,
        delivery_longitude: pricingOptions.delivery_longitude,
        request_id: pricingOptions?.request_id || null,
      }

      return callObject
    }

    doPricingApiCall = (params) => {
      const onSuccess = params.onSuccess ? params.onSuccess : function() {}
      const onError = params.onError ? params.onError : function() {}
      const pricingOptions = params.pricingOptions ? params.pricingOptions : {}
      const pricingDescription = params.pricingDescription

      const callObject = this.buildCallObject(pricingOptions)

      let fetchURL = 'pricing/motorcycles'
      apiProcess(fetchURL, callObject, 'calculate-total', pricingDescription)
        .then(
          function(responseData) {
            onSuccess(responseData.pricing)
            this.setState({
              pricingInfo: responseData.pricing,
              loading: false,
              hasPricingInfo: true,
              pricingError: false,
            })
          }.bind(this)
        )
        .catch(
          function(responseData) {
            onError()
            this.setState({
              loading: false,
              pricingError: true,
            })
          }.bind(this)
        )
    }

    resetPricing = () => {
      this.setState({
        loading: false,
        hasPricingInfo: false,
        pricingError: false,
        pricingInfo: {},
      })
    }

    render() {
      return (
        <WrappedComponent
          {...this.props}
          pricingLoading={this.state.loading}
          doPricing={this.doPricingApiCall}
          resetPricing={this.resetPricing}
          hasPricingInfo={this.state.hasPricingInfo}
          pricingError={this.state.pricingError}
          pricingInfo={this.state.pricingInfo}
          setPricingInitialValues={this.giveDefaultValues}
        />
      )
    }
  }
}
